import React from 'react';
import { BrowserRouter, Switch, Route, Link, NavLink } from "react-router-dom"

import Auth from '../Auth'


class Nav extends React.Component {

	logout() {
		this.props.appState.currentUser.signOut()
		this.props.history.push({ pathname: "/" });
		Auth.update(true)
	}


	render() {
		return (
			<nav className="navbar navbar-expand-lg navbar-light">
				{/* <div className="container-fluid"> */}
				<Link to="/" className="navbar-brand font-weight-500"><img src="/reconfig-logo.svg" className="logo" /></Link>
				<button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarNav">
					<ul className="navbar-nav mr-auto">
					</ul>
					{!this.props.hideLogin &&

						<ul className="navbar-nav">
							{this.props.appState.currentUser == null &&
								<li className="nav-item"><NavLink to={{ pathname: "/login", search: '?mode=login', state: { from: this.props.location } }} className="nav-link" activeClassName="active">Login</NavLink></li>
							}
							{this.props.appState.currentUserAttributes &&
								<>
									{/* <li className="nav-item"><NavLink to={{ pathname: "/profile", state: { from: this.props.location } }} className="nav-link" activeClassName="active"><small>{this.props.appState.currentUserAttributes.email}</small> <i className="icon ion-ios-contact"></i></NavLink></li> */}

									<li className="nav-item dropdown">
										<a className="nav-link dropdown-toggle font-weight-500" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" ><i className="icon ion-ios-contact"></i> <small>{this.props.appState.currentUserAttributes.email}</small> </a>
										<div className="dropdown-menu dropdown-menu-right shadow" >
											<NavLink to={{ pathname: "/profile", state: { from: this.props.location } }} className="dropdown-item" activeClassName="active">Account</NavLink>
											<div className="dropdown-divider"></div>
											<a role="button" className="dropdown-item small" href="mailto:contact@reconfig.cloud" target="_blank">Help & Support <i className="icon ion-md-mail ml-1"></i></a>
											<a role="button" className="dropdown-item small" href="mailto:feedback@reconfig.cloud" target="_blank">Feedback <i className="icon ion-md-mail ml-1"></i></a>
											<a role="button" className="dropdown-item small" onClick={(e) => { e.preventDefault(); this.logout() }}>Log out</a>
										</div>
									</li>

								</>
							}
						</ul>
					}
				</div>
				{/* </div> */}
			</nav>
		)
	}

}

export default Nav
